// Exports
export default {
	"container": "container_ipiWm",
	"element": "element_PBMRs"
};
